// extracted by mini-css-extract-plugin
module.exports = {"termsOfService":"TermsOfService_termsOfService__3kCI5","textLink":"TermsOfService_textLink__3JYZG"};